import formatCurrency from '../formatCurrency/index.js';

/**
 * Formatted Currency Constrained
 *
 * Returns a currency in a fixed 2 decimal format
 *
 */

export default function formatCurrencyConstrained(number, currency) {
  // Holds a number to two decimal places
  const finalNumber = number.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  return formatCurrency(finalNumber, currency);
}